import script from "./TabFieldGrowth.vue?vue&type=script&setup=true&lang=js"
export * from "./TabFieldGrowth.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__